import { render, staticRenderFns } from "./placard_manuscript.vue?vue&type=template&id=0608965c&scoped=true"
import script from "./placard_manuscript.vue?vue&type=script&lang=js"
export * from "./placard_manuscript.vue?vue&type=script&lang=js"
import style0 from "./placard_manuscript.vue?vue&type=style&index=0&id=0608965c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0608965c",
  null
  
)

export default component.exports